import { useMemo } from "react";

import type { CreateFeedbackVotePayload } from "@jti/rest-api";
import { FeedbackVotesApi } from "@jti/rest-api";

type FeedbackVoteSummaryFilter = Parameters<FeedbackVotesApi["getVoteSummary"]>[3];
type FeedbackVoteReferenceType = Parameters<FeedbackVotesApi["getVoteSummary"]>[1];

export const useFeedbackVotes = () => {
  const feedbackVotesApi = useMemo(() => FeedbackVotesApi.init(), []);

  return {
    submitVote: (payload: CreateFeedbackVotePayload) => feedbackVotesApi.createVote(payload),

    getUserVote: (url: string, referenceType: FeedbackVoteReferenceType, referenceName: string) =>
      feedbackVotesApi.getVote(url, referenceType, referenceName),

    getVoteSummary: (
      url: string,
      referenceType: FeedbackVoteReferenceType,
      referenceName: string,
      filter?: FeedbackVoteSummaryFilter
    ) => feedbackVotesApi.getVoteSummary(url, referenceType, referenceName, filter),
  };
};
